// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> eleven-oaks
// Generated: 2026-10-29T18:35:32.382Z
// Counts: 0 design, 26 content, 45 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, granite countertops, stainless steel appliances, smart-home tech, and an in-home washer and dryer make daily life easy. Outside, the private park, playground, dog park, and fire pit with BBQ grills are close by, and lawn maintenance is handled for you. See every feature on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to play, grill, and unwind</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Eleven Oaks, the shared spaces sit right outside your door: a fenced dog park and a playground under mature oaks, a fire pit and BBQ grills for easy evenings, and an open private park at the heart of the community.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter changes, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Move-in savings on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>New rental homes under the oaks of Eustis</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Eleven Oaks, the shared spaces fit right into an ordinary week: morning laps around the dog park, after-school time at the playground and private park, and weekend cookouts at the BBQ grills and fire pit. See the full list of <a href=\"/amenities\">community amenities</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From E Orange Avenue, it's a quick drive to the shops and restaurants of Historic Downtown Eustis and the Lake Eustis waterfront, and US-441 gets you to Mount Dora and Tavares in minutes. Find more local favorites on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Lake-country living near downtown Eustis</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs settle right in at Eleven Oaks, where a fenced, oak-shaded dog park with waste stations and open green space make daily walks easy. For longer outings, Ferran Park's lakefront promenade along Lake Eustis is just a short drive away; see the <a href=\"/neighborhood\">neighborhood guide</a> for more.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through all six plans in 3D, from the White Oak to the Banyan Oak, on our <a href=\"/virtual-tours\">virtual tours</a>, then see a home in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside six Eleven Oaks homes in 3D—the Laurel Oak, Willow Oak, Chapman Oak, White Oak, Scarlet Oak and Banyan Oak—so pick a tour and explore each layout room by room before you <a href=\"/floor-plans\">compare floor plans</a>.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Private Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-7f1e-740d-a023-545b64e98607.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open green lawn with townhome buildings in the background at Eleven Oaks"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-8829-7129-8ff1-f70e3c326605.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Single-family home with a neatly kept lawn and landscaping"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-8ab7-7591-9740-548ffdb37123.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Close-up of a smart thermostat mounted on a wall"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-8591-70c2-bcdb-b474ef1d7bf7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community playground with swings and slides"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-7a2a-70e8-aa5b-5d5539566f35.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced dog park with wood chip ground cover, benches, and large oak trees"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Washer/Dryer"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-377f-70bc-9d82-6178075b0a79.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community fire pit patio with blue chairs and a table at Eleven Oaks"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-7a8c-702d-b241-bf74872d0bec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a newly developed neighborhood with townhomes and houses surrounding a central green space."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-53ad-752d-b26a-df74357757c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern open-concept kitchen and living room with stainless steel appliances and a large sliding glass door leading to a patio."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-3777-768f-bf03-2a49ee2e6429.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced dog park with a waste station shaded by a large oak tree"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-29d9-749b-9dcf-be79c8780ad9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A playground with a slide and swings in a grassy area."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-7857-70a7-b884-e17f86aef444.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor seating area with a fire pit and chairs, picnic table with canopy, and grills."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fire Pit"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-7f1e-740d-a023-545b64e98607.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open lawn of the private park with townhome-style buildings beyond"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Private Park"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-8aa8-745c-ac50-d05c28a483f8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Mature oak trees draped with Spanish moss against a clear blue sky."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Oak Canopy"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-8ab7-7591-9740-548ffdb37123.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Smart thermostat mounted on a wall inside an Eleven Oaks home"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Smart Home"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-d94c-7631-b6cb-b05be4161fc4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Eleven Oaks single-family rental home with two-car garage and landscaped front yard"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-9595-76ee-892e-4e4879e6899f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with queen bed, tray ceiling and large windows"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-53ad-752d-b26a-df74357757c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept kitchen and living room with stainless appliances and sliding glass door to the patio"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-98e2-7502-b393-eda030bfcf1f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Single-family homes with garages framed by oak trees draped in Spanish moss"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-5527-72b8-a525-38a1e35157ca.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished open living room with sectional sofa, wood-look floors and kitchen island"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-6674-713f-ba57-f2a282ed5712.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Eleven Oaks townhome-style homes surrounding a central green space"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-87f0-75bd-9e8f-fdfcf32ef102.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community fire pit seating area with BBQ grills"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-8b2e-726f-89c2-9f3afb9e1385.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops, stainless steel appliances and island"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-29d9-749b-9dcf-be79c8780ad9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community playground with slides and swings on a grassy lawn"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-9715-776a-ae47-38aa677acb7a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Single-family home with a blue front door, garage and green lawn"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to unwind"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Stretch out in the private park and landscaped green space, or let the kids burn off energy at the playground while you take a breather."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Gather outdoors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Fire up the BBQ grills for a neighborhood cookout, then pull up a chair at the fire pit area as the evening cools down."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Space to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Two- and three-bedroom layouts leave room for a home office, and smart-home technology plus included lawn maintenance keep chores off your plate."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-fd23-7176-970c-1d88156e0081.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Ferran Park on the Lake Eustis waterfront in downtown Eustis"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Ferran Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-8570-71ca-a128-ef88bca28470.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A fenced-in dog park with wood chip ground cover and mature trees."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Fenced dog park"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-a4cc-74d3-8392-466576a1fff0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Eleven Oaks townhomes and single-family homes around a central park"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Eleven Oaks Community"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-5527-72b8-a525-38a1e35157ca.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open concept living room and kitchen with hardwood floors, a sectional sofa, and a kitchen island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living & Kitchen"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a92-79ed-71d0-b105-0f042b3ddb2b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Three single-family homes with garages are visible under a canopy of large oak trees draped with Spanish moss."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Homes Under the Oaks"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f633-72eb-9ae9-8e751084e8e9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with island, granite countertops, white cabinets, and stainless steel refrigerator"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchen"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-29d9-749b-9dcf-be79c8780ad9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community playground with slides and swings on a grassy lawn"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-3777-768f-bf03-2a49ee2e6429.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced dog park shaded by a mature oak tree with a waste station"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167576/01a15a91-9715-776a-ae47-38aa677acb7a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Single-family rental home at Eleven Oaks with an attached garage, blue front door and green front lawn"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
